import routes from '../routes';
export const ROUTE = {

  "ATD_NEW_TEST-DASHBOARD-ALL RIGHTS-ATD::DASHBOARD": `/${routes.mainRoute}/${routes.containers.dashboard}`,

  "ATD_NEW_TEST-MEDIAPLAN-ALL RIGHTS-ATD::MEDIAPLAN": `/${routes.mainRoute}/${routes.containers.mediaPlan}`,

  "ATD_NEW_TEST-CAMPAIGN-ALL RIGHTS-ATD::CAMPAIGN": `/${routes.mainRoute}/${routes.containers.campaignList}`,

  "ATD_NEW_TEST-ADMINMARGIN-ALL RIGHTS-ATD:ADMINMARGIN": `/${routes.mainRoute}/${routes.containers.adminMargin}`,

  "ATD_NEW_TEST-MARGIN-ALL RIGHTS-ATD::MARGIN": `/${routes.mainRoute}/${routes.containers.margin}`,

  "ATD_NEW_TEST-RO-ALL RIGHTS-ATD::RO": `/${routes.mainRoute}/${routes.containers.goals}/${routes.containers.ro}`,

  "ATD_NEW_TEST-UNMAPPEDCAMPAIGN-ALL RIGHTS-ATD::UNMAPPED": `/${routes.mainRoute}/${routes.containers.goals}/${routes.containers.unmappedCampaign}`,

  "ATD_NEW_TEST-RECOMMENDATIONS-ALL RIGHTS-ATD::RECOMMENDATIONS": `/${routes.mainRoute}/${routes.containers.optimizer}`,

  "ATD_NEW_TEST-DATA CONFIG-ALL RIGHTS-ATD::DATACONFIG": `/${routes.mainRoute}/${routes.containers.dataConfig}`,

  // "ATD_NEW_TEST-PAYMENT-ALL RIGHTS-ATD :: PAYMENT": `/${routes.mainRoute}/${routes.containers.payment}`,


  'ATD ADMIN-ADMIN-VIEW-LOGIN :: ADMIN :: VIEW': `/${routes.mainRoute}/${routes.containers.admin}`,
  'ATD ADMIN-TENANT-VIEW-LOGIN :: ADMIN :: TENANT': `/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.tenant.name}`,
  'ADMIN-FEATURES-VIEW-LOGIN :: ADMIN :: FEATURES': `/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.features.name}`,
  'ATD ADMIN-USERS-VIEW-LOGIN :: ADMIN :: USER': `/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.user.name}`,
  'ATD ADMIN-PROFILE-VIEW-LOGIN :: ADMIN :: PROFILE': `/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.account.name}`,
  'ATD ADMIN-DATA CONFIG-VIEW-LOGIN :: ADMIN :: DATA CONFIG': `/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.dataConfig.variables.name}`,
  "ATD ADMIN-CONNECTION MANAGEMENT-VIEW-LOGIN :: ADMIN :: CONNECTION MANAGEMENT": `/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.connection.name}`,
  'ATD ADMIN-SUBSCRIPTION PLAN MANAGER-VIEW-LOGIN :: ADMIN :: SUBSCRIPTION PLAN MANAGER': `/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.subscriptionPlanMgr.name}`,

  // Payment
  "ATD PAYMENT SUBSCRIPTION-PAYMENT-VIEW-LOGIN :: PAYMENT :: PAYMENT-VIEW": `/${routes.mainRoute}/${routes.containers.payment}`,
  "PAYMENT-ADD PAYMENT-ADD-LOGIN :: PAYMENT :: ADD PAYMENT": `${routes.mainRoute}/${routes.containers.payment}/${routes.payment.addPayment.name}`,
  "ATD PAYMENT SUBSCRIPTION-TRANSACTION HISTORY-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: TRANSACTION HISTORY": `/${routes.mainRoute}/${routes.containers.payment}/${routes.payment.billingHistory.name}`,
  "ATD PAYMENT SUBSCRIPTION-INVOICE-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: INVOICE": `/${routes.mainRoute}/${routes.containers.payment}/${routes.payment.invoice.name}`,
  "ATD PAYMENT SUBSCRIPTION-SUBSCRIPTION PLAN-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: SUBSCRIPTION PLAN": `${routes.mainRoute}/${routes.containers.payment}/${routes.payment.subscription.name}`,
  'ATD_NEW_TEST-AUDIENCE HIERARCHY-ALL RIGHTS-ATD :: AUDIENCE :: AUDIENCE HIERARCHY' : `/${routes.mainRoute}/${routes.containers.audience}/${routes.audience.audienceHierarchy.name}`,
  'ATD_NEW_TEST-HIERARCHY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: HIERARCHY MANAGER' : `/${routes.mainRoute}/${routes.containers.audience}/${routes.audience.hierarchyManager.name}`,
  'ATD_NEW_TEST-TAXONOMY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: TAXONOMY MANAGER' : `/${routes.mainRoute}/${routes.containers.audience}/${routes.audience.taxonomyManager.name}`,
  'ATD_NEW_TEST-DATA CAPTURE-ALL RIGHTS-ATD :: AUDIENCE :: DATA CAPTURE' : `/${routes.mainRoute}/${routes.containers.audience}/${routes.audience.dataCapture.name}`, 

  // creative 
  'ATD CREATIVE-CREATIVE-VIEW-LOGIN :: CREATIVE :: VIEW':`/${routes.mainRoute}/${routes.containers.creative}`,

  // audience
  'ATD AUDIENCE-AUDIENCE-VIEW-LOGIN :: AUDIENCE':`/${routes.mainRoute}/${routes.containers.audience}`



}
